import { render, staticRenderFns } from "./changepayment_v1.vue?vue&type=template&id=0872d5f0&"
import script from "./changepayment_v1.vue?vue&type=script&lang=js&"
export * from "./changepayment_v1.vue?vue&type=script&lang=js&"
import style0 from "./changepayment_v1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports